import React, { useEffect, useState } from 'react';
import { IoNewspaperOutline } from 'react-icons/io5';
import { BackendLink, SmartNewsCard } from '../../../Components';
import './ImportantNewsSec.css';

const ImportantNewsSec = () => {
    const [importantNews, setImportantNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchImportantNews = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllNews/`);
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const data = await response.json();
                const filteredNews = data.filter(news => news.important);
                setImportantNews(filteredNews);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchImportantNews();
    }, []);

    return (
        <div className='important-newsSec' data-aos="fade-up">
            <h1 className='newsSec-title'>
                <IoNewspaperOutline />
                News
            </h1>
            <ul className="all-importantNews main-bg-linear">
                {(loading || error || importantNews.length === 0
                    ? Array.from({ length: 3 }).map((_, index) => (
                        <SmartNewsCard
                            key={index}
                            loading={loading}
                            error={!!error || importantNews.length === 0}
                            news={null}
                        />
                    ))
                    : importantNews.map((news, index) => (
                        <SmartNewsCard
                            key={news.id}
                            loading={false}
                            error={false}
                            news={news}
                        />
                    ))
                )}
            </ul>
        </div>
    );
}

export default ImportantNewsSec;
